import { ConvertedFileInterface } from '../types/form.types';

const useConvertFile = (): ((
  file: File
) => Promise<ConvertedFileInterface>) => {
  const file2Base64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (): void | null => {
        return reader.result ? resolve(reader.result.toString()) : null;
      };

      reader.onerror = (error): void => reject(error);
    });
  };

  return async (file: File): Promise<ConvertedFileInterface> => {
    const { name, type: mime_type } = file;
    const convertedFile = await file2Base64(file);

    const [, content] = convertedFile.toString().split(',');
    return { name, mime_type, content };
  };
};

export default useConvertFile;
